import React from 'react';

import MainButton from '../button/Button';
import AttachFileNoteList from './AttachFileNoteList';
import FileItem from './FileItem';
import QuestionMark from './icons/question-mark.svg';
import TrashIcon from './icons/trash.svg';

export interface IFileItem {
  isChecked: boolean;
  file: File;
}

interface Props {
  inputRef: React.RefObject<HTMLInputElement>;
  isFileSizeValid: boolean;
  isFilesMaxCountValid: boolean;
  files: IFileItem[];
  onChange: () => void;
  onItemChange: (fileName: string) => void;
  onRemove: () => void;
  disabled?: boolean;
  contactFormRole?: string;
  attachmentHeadings: {
    AttachCV: string;
    TotalSize: string;
    RemoveSelected: string;
    AllowedTypes: string;
    HighSize: string;
    TooMuchFilesValidation: {
      Description: string;
    };
  };
}

const FILE_EXTENSIONS =
  '.jpg,.jpeg,.png,.gif,.doc,.docx,.ppt,.pptx,.pdf,.txt,.rtf,.odt,.ods,.odg,.odp,.xls,.xlsx,.xlxs,.vcf,.vcard,.key,.rar,.zip,.7z,.gz,.gzip,.tar,';

const FileInput: React.FC<Props> = ({
  inputRef,
  files,
  isFileSizeValid,
  isFilesMaxCountValid,
  onChange,
  onItemChange,
  onRemove,
  disabled,
  attachmentHeadings,
  contactFormRole,
}) => {
  return (
    <div className="attachment">
      <div className="attachment-container">
        <label htmlFor="attachment">
          <MainButton className="button outlined" component="span" disabled={disabled}>
            {attachmentHeadings.AttachCV}
          </MainButton>
        </label>
        <input
          ref={inputRef}
          type="file"
          id="attachment"
          className="attach-file"
          onChange={onChange}
          contact-form-role={contactFormRole}
          accept={FILE_EXTENSIONS}
          multiple
          disabled={disabled}
        />
        <div className="attach-file-mark">
          <QuestionMark />
          <div className="attach-file-note">
            <p className="attach-file-note-paragraph">{attachmentHeadings.TotalSize}</p>
            <p className="attach-file-note-paragraph paragraph-bolder">{attachmentHeadings.AllowedTypes}</p>
            <AttachFileNoteList />
          </div>
        </div>
      </div>
      <div className="file-list">
        {!isFilesMaxCountValid && (
          <p className="validation-message">{attachmentHeadings.TooMuchFilesValidation.Description}</p>
        )}
        {!isFileSizeValid && <p className="validation-message">{attachmentHeadings.HighSize}</p>}
        {files.map((fileItem) => (
          <FileItem key={fileItem.file.name} file={fileItem.file} onChange={onItemChange} disabled={disabled} />
        ))}
      </div>
      {files.length > 0 && (
        <MainButton className="button outlined button-remove" onClick={onRemove} component="span" disabled={disabled}>
          <TrashIcon />
          {attachmentHeadings.RemoveSelected}
        </MainButton>
      )}
    </div>
  );
};

export default FileInput;
